import React from 'react';
import PropTypes from 'prop-types';
import { Icon as SemanticIcon } from 'semantic-ui-react';

import {
  Button,
  Input,
  ContainerInput,
  ContainerText,
  Modal,
  Content,
  ContentRow,
  Actions,
  ErrorMessage,
} from './styles';

const ModalWithInput = (props) => {
  const {
    open,
    onClose,
    value,
    error,
    onInputChange,
    submit,
    buttonText,
    label,
    icon,
    loading,
  } = props;

  return (
    <Modal
      size="mini"
      open={open}
      closeOnEscape
      closeOnDimmerClick
      onClose={onClose}
    >
      <Content>
        <ContentRow>
          <ContainerText>
            {label}
          </ContainerText>
          <ContainerInput>
            <Input
              onChange={onInputChange}
              value={value}
            />
          </ContainerInput>
        </ContentRow>
        {error && (
          <ContentRow>
            <ErrorMessage>{error}</ErrorMessage>
          </ContentRow>
        )}
      </Content>
      <Actions>
        <Button loading={loading} onClick={submit}>
          {icon && (<SemanticIcon name={icon} />)}
          {buttonText}
        </Button>
      </Actions>
    </Modal>
  );
};

ModalWithInput.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  error: PropTypes.string,
  loading: PropTypes.bool,
  buttonText: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.string,
};

ModalWithInput.defaultProps = {
  open: false,
  value: '',
  error: null,
  loading: false,
  buttonText: '',
  label: '',
  icon: null,
};

export default ModalWithInput;
